export const onResize = function (conditions = []) {
  if (!conditions || (conditions && !conditions.length)) return;
  window.addEventListener('resize', () => {
    conditions.forEach((condition) => {
      if (!condition.callback) return;

      const { xMin, xMax, yMin, yMax, callback, trigger } = condition;
      if (xMin && window.innerWidth > xMin && trigger()) {
        callback();
        return;
      }

      if (xMax && window.innerWidth < xMax && trigger()) {
        callback();
        return;
      }

      if (yMin && window.innerHeight > yMin && trigger()) {
        callback();
        return;
      }

      if (yMax && window.innerHeight < yMax && trigger()) {
        callback();
        return;
      }

      if (!xMin && !xMax && !yMin && !yMax && trigger()) callback();
    });
  });
};
